import { makeAutoObservable } from "mobx";
import { ZIdName } from "src/types/ZIdName";
import { ZUid } from "src/types/zUid";
import { loadObjectAttrinbutesAll } from "src/pages/ManagementPage/objectsApi";

export const mc2SettingsStore = makeAutoObservable({
  modelObjectId: "" as ZUid,
  setModelObjectId(id: ZUid) {
    this.modelObjectId = id;
  },
  objectOptions: [] as ZIdName[],
  setObjectOptions(list: ZIdName[]) {
    this.objectOptions = list;
  },
  async init(modelObjectId: ZUid, loadObjectOptions: () => Promise<ZIdName[]>) {
    this.attrDict = {};
    this.setModelObjectId(modelObjectId);
    const objOptions = await loadObjectOptions();
    this.setObjectOptions(objOptions);
  },
  attrDict: {} as Record<ZUid, ZIdName[]>,

  async updateAttrs(objId: ZUid) {
    if (!this.attrDict[objId]) {
      this.attrDict[objId] = []; // чтобы при повторном вызове не делались дублирующие запросы, пока не загрузится
      const attrs = await loadObjectAttrinbutesAll(objId, { translate: true });
      this.attrDict[objId] = attrs;
    }
  },
});
